import NavbarComponent from "./component/CommonComponent/NavBar/NavBar";
import DemoNavbarComponent from "./component/CommonComponent/NavBar/DemoNavBar";
// import Home from "./component/HomePage/Home";
// import About from "./component/AboutPage/About";
// import LeanSuite from "./component/WhatLeanSuit/LeanSuite";
// import Report from "./component/ReportPage/Report";
// import Blogs from "./component/BlogPage/Blogs";
// import Contact from "./component/ContactPage/Contact";
// import Blog from "./component/BlogPage/SingleBlog/Blog";
// import Attachment from "./component/AttachmentTool/Attachment";
// import Campaign from "./component/Campaign/Campaign";
// import SuggestionPage from "./component/SuggestionPlatform/SuggestionPage";
// import PointsLeader from "./component/PointsLeaderboard/PointsLeader";
// import SuggestionOperations from "./component/SuggestionOperations/SuggestionOperation";
// import LMS from "./component/LMSPage/LMS";
// import RolesandPermissions from "./component/RolesPermissionsPage/RolesandPermissions";
// import TemplateBuilder from "./component/TemplateBuilder/TemplateBuilder";
// import Partners from "./component/PartnersPage/Partners";
// import QAMatrix from "./component/QAMatrixPage/QAMatrix";
// import Demo from "./component/DemoPage/Demo";
// import StepForm from "./component/StepsForm/StepForm";
// import Category from "./component/BlogPage/CategoryPage/Category";
// import Careers from "./component/CareersPage/Careers";
import { BrowserRouter as Router, Route, Switch, useLocation, Redirect } from "react-router-dom";
// import PageNotFound from "./component/PageNotFound/PageNotFound";
// import ContinuousImprovement from "./component/ContinuousImprovementPage/ContinuousImprovement";
// import Press from "./component/PressPage/Press";
// import IssueTracker from "./component/Issuetracker/IssueTracker";
// import OperationMaintenance from "./component/OperationMaintenance/OperationMaintenance";
// import ManagementQuality from "./component/ManagementQuality/ManagementQuality";
// import Rca from "./component/RCA/Rca";
// import Competency from "./component/Competency/Competency";
// import Price from "./component/Pricing/Price";
// import SafetyImprovement from "./component/SafetyImprovementPage/SafetyImprovement";
// import QualityImprovement from "./component/QualityImprovement/QualityImprovement";
// import OperationalExcellence from "./component/OperationalExcellence/OperationalExcellence";
// import CostReduction from "./component/CostReduction/CostReduction";
// import WorkforceEnablement from "./component/WorkforceEnablement/WorkforceEnablement";
// import Resources from "./component/Resources/Resources";
// import Resource from "./component/Resources/SingleResource/Resource";
// import Legal from "./component/LegalPages/Legal";
// import DemoScheduler from "./component/DemoPage/DemoScheduler";
// import GembaWalker from "./component/GembaWalker/GembaWalker";
// import CilrManagement from "./component/CilrManagement/CilrManagement";
// import CustomizableFields from "./component/CustomizableFields/CustomizableFields";
// import MarketPlace from "./component/MarketPlace/MarketPlace";
// import SignUp from "./component/SignUp/SignUp";
// import JobCoverMatrix from "./component/JobCoverMatrix/JobCoverMatrix";
// import ViewAllOpportunities from "./component/ViewAllOpportunities/ViewAllOpportunities";
// import LossandCost from "./component/LossandCost/LossandCost";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import ResourceLanding from "./component/Resources/ResourceLandingPage/ResourceLanding";
// import ResourceForm from "./component/Resources/ResourceForm/ResourceForm";
// import ResourceThankyou from "./component/Resources/ResourceThankyou/ResourceThankyou";
import { Suspense, lazy, useEffect, useState } from "react";
import Loader from "./utils/Loader";
import AISuggestion from "./component/AISuggestion/AISuggestion";
import AIQAmatrix from "./component/AIQAmatrix/AIQAmatrix";
import VideoLanding from "./component/Resources/VideoLandingPage/VideoLanding";
import ModalComponent from "./component/CommonComponent/ModalComponent";
import AnnouncementBanner from "./component/CommonComponent/NavBar/AnnouncementBanner";

const Home = lazy(() => import("./component/HomePage/Home"))
const Maintenance = lazy(() => import("./component/Maintenance/MaintenancePage"))


const About = lazy(() => import("./component/AboutPage/About"))
const LeanSuite = lazy(() => import("./component/WhatLeanSuit/LeanSuite"))
const Report = lazy(() => import("./component/ReportPage/Report"))
const Blogs = lazy(() => import("./component/BlogPage/Blogs"))
const Contact = lazy(() => import("./component/ContactPage/Contact"))
const Attachment = lazy(() => import("./component/AttachmentTool/Attachment"))
const Campaign = lazy(() => import("./component/Campaign/Campaign"))
const SuggestionPage = lazy(() => import("./component/SuggestionPlatform/SuggestionPage"))
const PointsLeader = lazy(() => import("./component/PointsLeaderboard/PointsLeader"))
const SuggestionOperations = lazy(() => import("./component/SuggestionOperations/SuggestionOperation"))
const LMS = lazy(() => import("./component/LMSPage/LMS"))
const RolesandPermissions = lazy(() => import("./component/RolesPermissionsPage/RolesandPermissions"))
const TemplateBuilder = lazy(() => import("./component/TemplateBuilder/TemplateBuilder"))
const Partners = lazy(() => import("./component/PartnersPage/Partners"))
const QAMatrix = lazy(() => import("./component/QAMatrixPage/QAMatrix"))
const Demo = lazy(() => import("./component/DemoPage/Demo"))
const SignupAI = lazy(() => import("./component/AIFeatures/SignupAI"))
const StepForm = lazy(() => import("./component/StepsForm/StepForm"))
const Category = lazy(() => import("./component/BlogPage/CategoryPage/Category"))
const Careers = lazy(() => import("./component/CareersPage/Careers"))
const Blog = lazy(() => import("./component/BlogPage/SingleBlog/Blog"))
const PageNotFound = lazy(() => import("./component/PageNotFound/PageNotFound"))
const ContinuousImprovement = lazy(() => import("./component/ContinuousImprovementPage/ContinuousImprovement"))
const Press = lazy(() => import("./component/PressPage/Press"))
const IssueTracker = lazy(() => import("./component/Issuetracker/IssueTracker"))
const OperationMaintenance = lazy(() => import("./component/OperationMaintenance/OperationMaintenance"))
const ManagementQuality = lazy(() => import("./component/ManagementQuality/ManagementQuality"))
const Rca = lazy(() => import("./component/RCA/Rca"))
const Competency = lazy(() => import("./component/Competency/Competency"))
const Price = lazy(() => import("./component/Pricing/Price"))
const PriceNew = lazy(() => import("./component/Pricing/PriceNew"))
const SafetyImprovement = lazy(() => import("./component/SafetyImprovementPage/SafetyImprovement"))
const QualityImprovement = lazy(() => import("./component/QualityImprovement/QualityImprovement"))
const OperationalExcellence = lazy(() => import("./component/OperationalExcellence/OperationalExcellence"))
const CostReduction = lazy(() => import("./component/CostReduction/CostReduction"))
const WorkforceEnablement = lazy(() => import("./component/WorkforceEnablement/WorkforceEnablement"))
const Resources = lazy(() => import("./component/Resources/Resources"))
const Resource = lazy(() => import("./component/Resources/SingleResource/Resource"))
const Legal = lazy(() => import("./component/LegalPages/Legal"))
const DemoScheduler = lazy(() => import("./component/DemoPage/DemoScheduler"))
const GembaWalker = lazy(() => import("./component/GembaWalker/GembaWalker"))
const CilrManagement = lazy(() => import("./component/CilrManagement/CilrManagement"))
const CustomizableFields = lazy(() => import("./component/CustomizableFields/CustomizableFields"))
const MarketPlace = lazy(() => import("./component/MarketPlace/MarketPlace"))
const SignUp = lazy(() => import("./component/SignUp/SignUp"))
const JobCoverMatrix = lazy(() => import("./component/JobCoverMatrix/JobCoverMatrix"))
const ViewAllOpportunities = lazy(() => import("./component/ViewAllOpportunities/ViewAllOpportunities"))
const LossandCost = lazy(() => import("./component/LossandCost/LossandCost"))
const ResourceLanding = lazy(() => import("./component/Resources/ResourceLandingPage/ResourceLanding"))
const ResourceForm = lazy(() => import("./component/Resources/ResourceForm/ResourceForm"))
const ResourceThankyou = lazy(() => import("./component/Resources/ResourceThankyou/ResourceThankyou"))
const DemoPopup = lazy(() => import("./component/DemoPage/DemoPopup"))
const NewsLetter = lazy(() => import("./component/NewsLetter/NewsLetter"))
const NewsLetterSuccess = lazy(() => import("./component/NewsLetter/NewsLetterSuccess"))
const UserDetails = lazy(() => import("./component/Reviews/UserDetails"))
const LikeToHear = lazy(() => import("./component/Reviews/LikeToHear"))
const RecordVideo = lazy(() => import("./component/Reviews/RecordVideo"))
const WriteComment = lazy(() => import("./component/Reviews/WriteComment"))
const ThankYou = lazy(() => import("./component/Reviews/ThankYou"))
const Revolutionize = lazy(() => import("./component/Revolutionize/Revolutionize"))
const KPIPage = lazy(() => import("./component/Revolutionize/KPIPage"))

function App() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if the modal has already been shown
    const modalShown = localStorage.getItem('modalShown');
    const modalTimestamp = localStorage.getItem('modalTimestamp');

    const currentTime = new Date().getTime();
    const modalShownBefore = modalShown === 'true';
    const modalRecentlyShown = modalTimestamp && (currentTime - parseInt(modalTimestamp, 10) < 12 * 60 * 60 * 1000);

    if (!modalShownBefore || !modalRecentlyShown) {
      // Show modal after 60 seconds if it hasn't been shown before or it's been more than 7 days
      const timer = setTimeout(() => {
        setShowModal(true);
        localStorage.setItem('modalShown', 'true'); // Set the flag in localStorage
        localStorage.setItem('modalTimestamp', currentTime.toString()); // Store the timestamp
      }, 60000); // 60 seconds

      return () => clearTimeout(timer); // Clean up on component unmount
    }
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const isMaintenanceMode = false;

  return (
    <div>
      <Router>
        {/* <NavbarComponent /> */}
        <AnnouncementBanner />
        {isMaintenanceMode ? (
          <Maintenance />
        ) :(
          <>
           <NavbarWithConditionalRendering />
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route exact path='/' component={Home} />
            <Route path='/demo' component={DemoPopup} />
            <Route exact path='/aboutus' component={About} />
            <Route exact path='/what-is-leansuite' component={LeanSuite} />
            <Route exact path='/reports' component={Report} />
            <Route exact path='/blog' component={Blogs} />
            {/* <Route exact path="/category/:id" component={Category} /> */}
            <Route exact path='/review' component={UserDetails} />
            <Route exact path='/love-to-hear-your-experience' component={LikeToHear} />
            <Route exact path='/record-your-video' component={RecordVideo} />
            <Route exact path='/write-your-review' component={WriteComment} />
            <Route exact path='/thank-you-for-review' component={ThankYou} />
            <Route exact path='/newsletter' component={NewsLetter} />
            <Route exact path='/newsletter-success' component={NewsLetterSuccess} />
            <Route exact path='/contact-us' component={Contact} />
            <Route exact path='/attachment-tool' component={Attachment} />
            <Route exact path='/campaign' component={Campaign} />
            <Route exact path='/qa-matrix' component={QAMatrix} />
            <Route exact path='/schedule-demo' component={Demo} />
            <Route exact path='/sign-up-for-ai' component={SignupAI} />
            <Route exact path='/careers' component={Careers} />
            <Route exact path='/learning-management-system' component={LMS} />
            <Route exact path='/suggestion-platform-for-hr' component={SuggestionPage} />
            <Route exact path='/category' component={Category} />
            <Route exact path='/category/:id/' component={Category} />
            {/* <Route exact path='/resources' component={Resources} /> */}
            <Route exact path='/resources/:resourceSlug/' component={Resources} />
            <Route path="/resources" render={() => <Redirect to="/resources/all" />} />
            <Route exact path="/resource/manufacturing-leadership-award-winner" render={() => <Redirect to="/manufacturing-leadership-award-winner" />} />
            <Route exact path="/resource/20-best-quotes-on-employee-engagement-leadership" render={() => <Redirect to="/20-best-quotes-on-employee-engagement-leadership" />} />
            <Route exact path="/resource/what-is-the-six-sigma-lean-methodology" render={() => <Redirect to="/what-is-the-six-sigma-lean-methodology" />} />
            <Route exact path="/resource/continuous-improvement-guide-for-beginners" render={() => <Redirect to="/continuous-improvement-guide-for-beginners" />} />
            <Route exact path="/resource/virtual-gemba-walk-app-benefits" render={() => <Redirect to="/virtual-gemba-walk-app-benefits" />} />
            <Route exact path="/resource/how-to-perform-an-effective-gemba-walk" render={() => <Redirect to="/how-to-perform-an-effective-gemba-walk" />} />
            <Route exact path="/resource/how-to-reduce-daily-manufacturing-waste" render={() => <Redirect to="/how-to-reduce-daily-manufacturing-waste" />} />
            <Route exact path="/resource/industry-partners-app-gets-upgraded-with-the-power-of-ai" render={() => <Redirect to="/industry-partners-app-gets-upgraded-with-the-power-of-ai" />} />
            <Route exact path="/resource/lean-transformation-a-complete-guide-for-beginners" render={() => <Redirect to="/lean-transformation-a-complete-guide-for-beginners" />} />
            <Route exact path="/resource/four-ways-manufacturers-can-improve-their-company-culture" render={() => <Redirect to="/four-ways-manufacturers-can-improve-their-company-culture" />} />
            <Route exact path="/resource/intrinsic-vs-extrinsic-motivation" render={() => <Redirect to="/intrinsic-vs-extrinsic-motivation" />} />
            <Route exact path="/resource/five-types-of-maintenance-strategies" render={() => <Redirect to="/five-types-of-maintenance-strategies" />} />
            <Route exact path="/resource/five-key-principles-of-continuous-improvement" render={() => <Redirect to="/five-key-principles-of-continuous-improvement" />} />
            <Route exact path="/resource/issue-tracking-in-manufacturing" render={() => <Redirect to="/issue-tracking-in-manufacturing" />} />
            <Route exact path="/resource/digital-transformation-in-manufacturing" render={() => <Redirect to="/digital-transformation-in-manufacturing" />} />
            <Route exact path="/resource/five-ways-to-improve-safety-on-the-shop-floor" render={() => <Redirect to="/five-ways-to-improve-safety-on-the-shop-floor" />} />
            <Route exact path="/resource/lean-six-sigma-tools-and-techniques" render={() => <Redirect to="/lean-six-sigma-tools-and-techniques" />} />
            <Route exact path="/resource/startup-canada-achieve-more-with-less-through-theleansuite-com" render={() => <Redirect to="/startup-canada-achieve-more-with-less-through-theleansuite-com" />} />
            <Route exact path="/resource/lean-manufacturing-definition-and-benefits" render={() => <Redirect to="/lean-manufacturing-definition-and-benefits" />} />
            <Route exact path="/resource/essential-gemba-walk-checklist-questions-to-ask" render={() => <Redirect to="/essential-gemba-walk-checklist-questions-to-ask" />} />
            <Route exact path="/resource/industrial-tech-buzzwords-you-need-to-know" render={() => <Redirect to="/industrial-tech-buzzwords-you-need-to-know" />} />
            <Route exact path="/resource/the-six-big-losses-in-lean-manufacturing" render={() => <Redirect to="/the-six-big-losses-in-lean-manufacturing" />} />
            <Route exact path="/resource/what-is-the-toyota-production-system" render={() => <Redirect to="/what-is-the-toyota-production-system" />} />
            <Route exact path="/resource/from-start-up-to-step-up-mississaugas-support-for-next-stage-growth" render={() => <Redirect to="/from-start-up-to-step-up-mississaugas-support-for-next-stage-growth" />} />
            <Route exact path="/resource/how-to-build-an-effective-recognition-program" render={() => <Redirect to="/how-to-build-an-effective-recognition-program" />} />
            <Route exact path="/resource/six-types-of-employee-rewards" render={() => <Redirect to="/six-types-of-employee-rewards" />} />
            <Route exact path="/resource/how-to-improve-production-quality-in-manufacturing" render={() => <Redirect to="/how-to-improve-production-quality-in-manufacturing" />} />
            <Route exact path="/resource/ways-to-reduce-manufacturing-costs" render={() => <Redirect to="/ways-to-reduce-manufacturing-costs" />} />
            <Route exact path="/resource/how-to-create-a-high-performance-culture" render={() => <Redirect to="/how-to-create-a-high-performance-culture" />} />
            <Route exact path="/resource/the-importance-of-the-5s-methodology" render={() => <Redirect to="/the-importance-of-the-5s-methodology" />} />
            <Route exact path="/resource/what-are-the-five-lean-manufacturing-principles" render={() => <Redirect to="/what-are-the-five-lean-manufacturing-principles" />} />
            <Route exact path="/resource/what-are-six-types-of-kaizen-methodologies" render={() => <Redirect to="/what-are-six-types-of-kaizen-methodologies" />} />
            <Route exact path="/resource/enhance-obeya-room-activities-with-leansuite" render={() => <Redirect to="/enhance-obeya-room-activities-with-leansuite" />} />
            <Route exact path="/resource/what-is-poka-yoke-in-lean-manufacturing" render={() => <Redirect to="/what-is-poka-yoke-in-lean-manufacturing" />} />
            <Route exact path="/resource/lean-manufacturing-organization-tools" render={() => <Redirect to="/lean-manufacturing-organization-tools" />} />
            <Route exact path="/resource/a-beginners-guide-to-value-stream-mapping" render={() => <Redirect to="/a-beginners-guide-to-value-stream-mapping" />} />
            <Route exact path="/resource/how-to-optimize-your-manufacturing-work-environment" render={() => <Redirect to="/how-to-optimize-your-manufacturing-work-environment" />} />
            <Route exact path="/resource/5-great-ideas-to-generate-employee-engagement-in-manufacturing-post-covid-19" render={() => <Redirect to="/5-great-ideas-to-generate-employee-engagement-in-manufacturing-post-covid-19" />} />
            <Route exact path="/resource/how-to-perform-an-effective-root-cause-analysis" render={() => <Redirect to="/how-to-perform-an-effective-root-cause-analysis" />} />
            <Route exact path="/resource/7-thoughtful-employee-recognition-ideas" render={() => <Redirect to="/7-thoughtful-employee-recognition-ideas" />} />
            <Route exact path="/resource/preventive-vs-predictive-maintenance" render={() => <Redirect to="/preventive-vs-predictive-maintenance" />} />
            <Route exact path="/resource/what-is-a-continuous-improvement-software" render={() => <Redirect to="/what-is-a-continuous-improvement-software" />} />
            <Route exact path="/resource/3-types-of-employee-recognition" render={() => <Redirect to="/3-types-of-employee-recognition" />} />
            <Route exact path="/resource/four-lean-tools-for-simple-problem-solving" render={() => <Redirect to="/four-lean-tools-for-simple-problem-solving" />} />
            <Route exact path="/resource/optimize-every-tier-in-manufacturing-with-leansuite" render={() => <Redirect to="/optimize-every-tier-in-manufacturing-with-leansuite" />} />
            <Route exact path="/resource/idea-mississauga-theleansuite" render={() => <Redirect to="/idea-mississauga-theleansuite" />} />
            <Route exact path="/resource/artificial-intelligence-in-manufacturing-the-benefits" render={() => <Redirect to="/artificial-intelligence-in-manufacturing-the-benefits" />} />
            <Route exact path="/resource/8-lean-manufacturing-software-tools-to-enhance-your-projects" render={() => <Redirect to="/8-lean-manufacturing-software-tools-to-enhance-your-projects" />} />
            <Route exact path="/resource/what-is-a-suggestion-system" render={() => <Redirect to="/what-is-a-suggestion-system" />} />
            <Route exact path="/resource/foster-a-culture-of-continuous-improvement-with-leansuite" render={() => <Redirect to="/foster-a-culture-of-continuous-improvement-with-leansuite" />} />
            <Route exact path="/resource/top-ways-to-keep-manufacturing-employees-engaged" render={() => <Redirect to="/top-ways-to-keep-manufacturing-employees-engaged" />} />
            <Route exact path="/resource/top-four-benefits-of-lean-manufacturing" render={() => <Redirect to="/top-four-benefits-of-lean-manufacturing" />} />
            <Route exact path="/resource/jidoka-a-quick-guide-for-beginners" render={() => <Redirect to="/jidoka-a-quick-guide-for-beginners" />} />
            <Route exact path="/resource/what-are-the-benefits-of-preventive-maintenance" render={() => <Redirect to="/what-are-the-benefits-of-preventive-maintenance" />} />
            <Route exact path="/resource/the-difference-between-planned-and-scheduled-maintenance" render={() => <Redirect to="/the-difference-between-planned-and-scheduled-maintenance" />} />
            <Route exact path="/resource/the-four-core-principles-of-kanban" render={() => <Redirect to="/the-four-core-principles-of-kanban" />} />
            <Route exact path="/resource/5-ways-to-empower-frontline-employees" render={() => <Redirect to="/5-ways-to-empower-frontline-employees" />} />
            <Route exact path="/resource/benefits-of-using-a-learning-management-system" render={() => <Redirect to="/benefits-of-using-a-learning-management-system" />} />
            <Route exact path="/resource/how-to-reduce-manufacturing-downtime" render={() => <Redirect to="/how-to-reduce-manufacturing-downtime" />} />
            <Route exact path="/resource/why-you-should-digitize-equipment-maintenance" render={() => <Redirect to="/why-you-should-digitize-equipment-maintenance" />} />
            <Route exact path="/resource/benefits-of-using-digital-work-instructions-in-manufacturing" render={() => <Redirect to="/benefits-of-using-digital-work-instructions-in-manufacturing" />} />
            <Route exact path="/resource/poka-yoke-examples-in-real-life" render={() => <Redirect to="/poka-yoke-examples-in-real-life" />} />
            <Route exact path="/resource/benefits-of-continuous-improvement" render={() => <Redirect to="/benefits-of-continuous-improvement" />} />
            <Route exact path="/resource/what-is-dmaic-pdca-in-lean-manufacturing" render={() => <Redirect to="/what-is-dmaic-pdca-in-lean-manufacturing" />} />
            <Route exact path="/resource/benefits-of-using-digital-forms-in-manufacturing" render={() => <Redirect to="/benefits-of-using-digital-forms-in-manufacturing" />} />
            <Route exact path="/resource/top-reasons-why-you-should-enforce-near-miss-reporting" render={() => <Redirect to="/top-reasons-why-you-should-enforce-near-miss-reporting" />} />
            <Route exact path="/resource/the-five-cs-action-tips-to-increase-employee-engagement-in-your-workplace" render={() => <Redirect to="/the-five-cs-action-tips-to-increase-employee-engagement-in-your-workplace" />} />
            <Route exact path="/resource/the-key-principles-of-kaizen" render={() => <Redirect to="/the-key-principles-of-kaizen" />} />
            <Route exact path="/resource/what-is-overall-equipment-effectiveness" render={() => <Redirect to="/what-is-overall-equipment-effectiveness" />} />
            <Route exact path="/resource/six-types-of-process-improvement-methodologies" render={() => <Redirect to="/six-types-of-process-improvement-methodologies" />} />
            <Route exact path="/resource/the-benefits-of-a-points-based-reward-system" render={() => <Redirect to="/the-benefits-of-a-points-based-reward-system" />} />

            <Route exact path="/resource/what-is-digital-manufacturing" render={() => <Redirect to="/what-is-digital-manufacturing" />} />
            <Route exact path="/resource/5g-methodology" render={() => <Redirect to="/5g-methodology" />} />
            <Route exact path="/resource/what-is-the-5-whys-analysis" render={() => <Redirect to="/what-is-the-5-whys-analysis" />} />
            <Route exact path="/resource/what-are-the-different-types-of-maintenance-workers" render={() => <Redirect to="/what-are-the-different-types-of-maintenance-workers" />} />

            {/* Add your redirects below */}
                <Route
                  exact
                  path="/the-five-elements-of-kaizen/__CANONICAL__"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/the-principles-of-total-quality-management/__CANONICAL__"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/asset-your-feedback/feed/"
                  render={() => <Redirect to="/asset-your-feedback/" />}
                />
                <Route
                  exact
                  path="/2022/04/29/"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/idea-mississauga-theleansuite/feed/"
                  render={() => <Redirect to="/idea-mississauga-theleansuite/" />}
                />
                <Route
                  exact
                  path="/category/business-concepts/"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/wp-content/plugins/jetpack/_inc/blocks/"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/benefits-of-using-a-learning-management-system/feed/"
                  render={() => <Redirect to="/benefits-of-using-a-learning-management-system/" />}
                />
                <Route
                  exact
                  path="/what-are-the-five-lean-manufacturing-principles/feed/"
                  render={() => <Redirect to="/what-are-the-five-lean-manufacturing-principles/" />}
                />
                <Route
                  exact
                  path="/resource/"
                  render={() => <Redirect to="/resources/all" />}
                />
                <Route
                  exact
                  path="/suggestion-platform/"
                  render={() => <Redirect to="/" />}
                />
                {/* <Route
                  exact
                  path="/what-is-a-continuous-improvement-software/feed/"
                  render={() => <Redirect to="/what-is-a-continuous-improvement-software/" />}
                /> */}

                {/* 2nd redirect */}
                <Route
                  exact
                  path="/home"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/dummy-post-the-basics-of-lean-manufacturing-a-guide-to-streamlining-your-production"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  exact
                  path="/dummy-post-the-future-of-comfort-and-style"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/duumy-post"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/1win-kazino-i-bk"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/pokerdom-ofitsialnyy-sayt-onlayn-kazino-pokerdom-2025"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/casino-utan-svensk-licens-spela-utan-spelpaus-och-begransningar"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/building-an-effective-recognition-program"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/hangug-onrain-kajino-sinroehalsu-issneun-peulraespomeseo-anjeonhago-jaemiissneun-geimeul-jeulgineun-bangbeobgwa-cuceon-saiteu"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/1win-casino-app-for-android-download-the-apk"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/1win-bukmekerskaya-kontora-1vin"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/azrbaycanda-glory-casino-il-n-maraqli-oyunlar-v-clbedici-bonuslar-sizi-gozlyir"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/issue-tracker/?amp=1"
                  render={() => <Redirect to="/" />}
                />
                {/* <Route
  exact
  path="/how-to-perform-an-effective-root-cause-analysis"
  render={() => <Redirect to="/" />}
/>
<Route
  exact
  path="/how-to-improve-shop-floor-productivity"
  render={() => <Redirect to="/" />}
/> */}
                <Route
                  exact
                  path="/elementor-46307"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/suggestion-operations"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/theleansuite-marketplace"
                  render={() => <Redirect to="/marketplace/" />}
                />
                <Route
                  exact
                  path="/why-you-should-use-a-virtual-gemba-walk"
                  render={() => <Redirect to="/" />}
                />

{/* 3rd redirect */}

                  <Route
                  exact
                  path="/resource"
                  render={() => <Redirect to="/resources/all" />}
                />
                <Route
                  exact
                  path="/suggestion-platform"
                  render={() => <Redirect to="/" />}
                />
                <Route
                  exact
                  path="/employee-engagement-guide"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  exact
                  path="/8-steps-to-launch-a-successful-suggestion-idea-program/"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  exact
                  path="/points-and-leadership/"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  exact
                  path="/schedule-a-demo-3-step/"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  exact
                  path="/digital-kaizen/"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  exact
                  path="/issue-tracker/"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  
                  path="/tag-management-system"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  exact
                  path="/digital-kaizen/?trk=products_details_guest_secondary_call_to_action"
                  render={() => <Redirect to="/blog" />}
                />
                <Route
                  exact
                  path="/employee-engagement-guide/"
                  render={() => <Redirect to="/blog" />}
                />
                 <Route
                  exact
                  path="/theleansuite-marketplace"
                  render={() => <Redirect to="/marketplace/" />}
                />
                <Route
                  exact
                  path="/what-is-operational-excellence-in-manufacturing/"
                  render={() => <Redirect to="/operational-excellence-in-manufacturing" />}
                />
                
            <Route exact path='/resource/:id/' component={Resource} />
            <Route
              exact
              path='/suggestion-platform-for-operations'
              component={SuggestionOperations}
            />
            <Route
              exact
              path='/points-and-leaderboard'
              component={PointsLeader}
            />
            <Route
              exact
              path='/roles-and-permissions'
              component={RolesandPermissions}
            />
            <Route exact path='/template-builder' component={TemplateBuilder} />
            <Route
              exact
              path='/theleansuite-partner-community'
              component={Partners}
            />
            <Route
              exact
              path='/continuous-improvement-for-operations'
              component={ContinuousImprovement}
            />
            <Route exact path='/press' component={Press} />
            <Route path='/issue-tracker-for-safety' component={IssueTracker} />
            <Route
              path='/issue-tracker-for-operations'
              component={OperationMaintenance}
            />
            <Route
              path='/issue-tracker-for-quality'
              component={ManagementQuality}
            />
            <Route path='/rca' component={Rca} />
            <Route path='/competency-management' component={Competency} />
            <Route exact path='/pricing' component={Price} />
            <Route exact path='/new-pricing' component={PriceNew} />
            <Route
              exact
              path='/safety-improvement'
              component={SafetyImprovement}
            />
            <Route
              exact
              path='/quality-improvement'
              component={QualityImprovement}
            />
            <Route
              exact
              path='/operational-excellence'
              component={OperationalExcellence}
            />
            <Route exact path='/cost-reduction' component={CostReduction} />
            <Route
              exact
              path='/workforce-enablement'
              component={WorkforceEnablement}
            />
            <Route exact path='/get-started-first-step' component={StepForm} />
            <Route path="/legal/:tab" component={Legal} />
            {/* Redirect to /legal/privacy if /legal is accessed */}
            <Route path="/legal" render={() => <Redirect to="/legal/privacy" />} />
            <Route exact path="/thank-you" component={DemoScheduler} />
            <Route exact path="/gemba-walker" component={GembaWalker} />
            <Route exact path="/cilr-management" component={CilrManagement} />
            <Route exact path="/customizable-forms" component={CustomizableFields} />
            <Route exact path="/marketplace" component={MarketPlace} />
            <Route exact path="/partner-sign-up" component={SignUp} />
            <Route exact path="/job-cover-matrix" component={JobCoverMatrix} />
            <Route exact path="/view-all-opportunities" component={ViewAllOpportunities} />
            <Route exact path="/loss-and-cost-management" component={LossandCost} />
            <Route exact path="/webinar-landing" component={ResourceLanding} />
            <Route exact path="/webinar-form" component={ResourceForm} />
            <Route exact path="/webinar-thanks" component={ResourceThankyou} />
            <Route exact path="/lean-creator" component={Revolutionize} />
            <Route exact path="/kpi-builder" component={KPIPage} />
            <Route exact path="/ai-suggestion" component={AISuggestion} />
            <Route exact path="/ai-qa-matrix" component={AIQAmatrix} />
            <Route exact path="/video-landing" component={VideoLanding} />
            <Route exact path='/:id/' component={Blog} />
            <Route path='*' component={PageNotFound} />
          </Switch>
        </Suspense>
          </>
        )}
       
      </Router>
      {/* Render the modal */}
      {/* <ModalComponent show={showModal} handleClose={handleCloseModal} /> */}
    </div>
  );
}

function NavbarWithConditionalRendering() {
  const location = useLocation();
  // List of routes where NavbarComponent should be hidden
  const hideNavbarRoutes = ['/get-started-first-step'];
  // List of routes where DemoNavbarComponent should be shown
  const showDemoNavbarRoutes = ['/schedule-demo','/sign-up-for-ai', '/video-landing'];
  // Check if current location matches any route that should hide NavbarComponent
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);
  // Check if current location matches any route that should show DemoNavbarComponent
  const shouldShowDemoNavbar = showDemoNavbarRoutes.includes(location.pathname);
  return (
    <>
      {shouldHideNavbar ? null : (shouldShowDemoNavbar ? <DemoNavbarComponent /> : <NavbarComponent />)}
    </>
  );
}

export default App;
